<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-border ts-border-gray-300 ts-rounded-lg ts-p-3 ts-mb-3">
      <form class="form-horizontal ts-space-y-2">
        <div class="row">
          <div class="col-md-6 ts-space-y-3">
            <div class="row">
              <label class="col-md-3 form-col-label control-label required">{{
                $t('serviceRequest.date')
              }}</label>
              <div class="col-md-9">
                <a-date-picker
                  v-model="model.generate_date"
                  class="ts-w-full"
                  valueFormat="DD-MM-YYYY"
                  format="DD-MM-YYYY"
                ></a-date-picker>
                <div class="validate" v-if="errors.has('generate_date')">
                  {{ errors.first('generate_date') }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 ts-space-y-3">
            <div class="row">
              <label class="col-md-3 form-col-label control-label required">{{
                $t('serviceRequest.owner/sale')
              }}</label>
              <div class="col-md-9">
                <a-select
                  v-model="model.seller_id"
                  :options="sales"
                  allowClear
                  show-search
                  option-filter-prop="children"
                  class="ts-w-full"
                  :class="{
                    'is-invalid': errors.has('seller_id')
                  }"
                  placeholder="Select"
                ></a-select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 ts-space-y-3">
            <div class="row">
              <label class="col-md-3 form-col-label control-label required">{{
                $t('serviceRequest.serviceRequestNo')
              }}</label>
              <div class="col-md-9">
                <a-select
                  v-model="model.service_request_id"
                  :options="serviceRequests"
                  allowClear
                  show-search
                  option-filter-prop="children"
                  class="ts-w-full"
                  :class="{
                    'is-invalid': errors.has('service_request_id')
                  }"
                  placeholder="Select"
                  @change="onChangeServiceRequest"
                  @search="handleSearchServiceRequest"
                  :loading="service_request_searching"
                ></a-select>
                <div class="validate" v-if="errors.has('service_request_id')">
                  {{ errors.first('service_request_id') }}
                </div>
              </div>
            </div>
            <div class="row">
              <label class="col-md-3 form-col-label control-label required">{{
                $t('serviceRequest.customer')
              }}</label>
              <div class="col-md-9">
                <div class="ts-border ts-border-gray-300 ts-rounded-md ts-space-y-1 ts-p-2 ts-mb-2">
                  <input
                    :value="
                      customer_info
                        ? customer_info.customer_name +
                          ' | ' +
                          customer_info.contact_number
                        : ''
                    "
                    type="text"
                    class="form-control"
                    style="height: 32px;"
                    readonly
                  />
                  <div class="row ts-pt-1">
                    <b class="col-md-3 ts-py-1 ts-text-right">
                      {{ $t('serviceRequest.creditAmount') }} :
                    </b>
                    <div class="col-md-9 ts-py-1">
                      <b class="ts-text-red-600">
                        {{ customer_info ? customer_info.credit_amount : 0 }}
                      </b>
                    </div>
                  </div>
                  <div class="row">
                    <b class="col-md-3 ts-py-1 ts-text-right">
                      {{ $t('serviceRequest.creditDay') }} :
                    </b>
                    <div class="col-md-9 ts-py-1">
                      <input
                        v-model.number="model.credit_day"
                        type="number"
                        class="ts-p-1 ts-h-6 ts-outline-none ts-border"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <label class="col-md-3 form-col-label control-label required">
                {{ $t('serviceRequest.payment') }}
              </label>
              <div class="col-md-9">
                <div
                  class="ts-border ts-border-gray-300 ts-rounded-md ts-space-y-2 ts-p-3"
                >
                  <div class="row">
                    <div class="col-md-6">
                      <label class="ts-mb-0 required">
                        {{ $t('serviceRequest.paymentMethod') }}
                      </label>
                      <a-select
                        v-model.number="model.payment_method_id"
                        @change="onPaymentMethodChange()"
                        :options="paymentMethods"
                        class="ts-w-full"
                      >
                      </a-select>
                      <div
                        class="validate"
                        v-if="errors.has('payment_method_id')"
                      >
                        {{ errors.first('payment_method_id') }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label
                        class="ts-mb-0"
                        :class="model.payment_method_id != 1 ? 'required' : ''"
                      >
                        {{ $t('serviceRequest.bankName') }}
                      </label>
                      <a-select
                        :disabled="model.payment_method_id == 1"
                        v-model.number="model.bank_name"
                        :options="bankProfiles"
                        @change="bankNameChange"
                        class="ts-w-full"
                      ></a-select>
                      <div class="validate" v-if="errors.has('bank_name')">
                        {{ errors.first('bank_name') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label
                        class="ts-mb-0 "
                        :class="model.payment_method_id != 1 ? 'required' : ''"
                      >
                        {{ $t('serviceRequest.accountNumber') }}
                      </label>
                      <a-select
                        v-if="model.payment_method_id != 2"
                        :disabled="model.payment_method_id == 1"
                        v-model="model.account_number"
                        :options="accountOptions"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        @change="accountChange"
                        class="ts-w-full"
                      ></a-select>
                      <input
                        type="text"
                        class="form-control"
                        v-if="model.payment_method_id == 2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 ts-space-y-3">
            <div class="row">
              <label class="col-md-3 form-col-label control-label required">{{
                $t('serviceRequest.vendorCustomer')
              }}</label>
              <div class="col-md-9">
                <div class="ts-border ts-border-gray-300 ts-rounded-md ts-space-y-1 ts-p-2">
                  <a-select
                    v-model="model.vendor_customer_id"
                    :options="vendorCustomers"
                    allowClear
                    show-search
                    option-filter-prop="children"
                    class="ts-w-full"
                    :class="{
                      'is-invalid': errors.has('vendor_customer_id')
                    }"
                    placeholder="Select"
                    @change="onChangeVendor"
                    @search="handleSearchCustomer"
                    :loading="customer_searching"
                  ></a-select>
                  <div class="row ts-pt-1">
                    <b class="col-md-3 ts-py-1 ts-text-right">
                      {{ $t('serviceRequest.creditAmount') }} :
                    </b>
                    <div class="col-md-9 ts-py-1">
                      <b class="ts-text-red-600">
                        {{ vendor_credit_amount ? vendor_credit_amount : 0 }}
                      </b>
                    </div>
                  </div>
                  <div class="row">
                    <b class="col-md-3 ts-py-1 ts-text-right">
                      {{ $t('serviceRequest.creditDay') }} :
                    </b>
                    <div class="col-md-9 ts-py-1">
                      <input
                        v-model.number="model.vendor_credit_day"
                        type="number"
                        class="ts-p-1 ts-h-6 ts-outline-none ts-border"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <label class="col-md-3 form-col-label control-label">
                {{ $t('serviceRequest.exchangeRate') }}
              </label>
              <div class="col-md-9">
                <div
                  class="ts-border ts-border-gray-300 ts-rounded-md ts-space-y-2 ts-p-1"
                >
                  <div class="row ts-pt-1">
                    <b class="col-md-3 ts-py-1 ts-text-right">
                      {{ $t('serviceRequest.fxKhrRate') }} :
                    </b>
                    <div class="col-md-3 ts-py-1">
                      <b class="ts-text-red-600">
                        {{ model.fx_rate_kh }}
                      </b>
                    </div>
                    <b class="col-md-3 ts-py-1 ts-text-right">
                      {{ $t('serviceRequest.fxThbRate') }} :
                    </b>
                    <div class="col-md-3 ts-py-1">
                      <b class="ts-text-red-600">
                        {{ model.fx_rate_thb }}
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ts-loading-banner>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'

export default {
  name: 'infoInvoice',
  props: ['value', 'validate'],
  data() {
    return {
      loading: false,
      service_request_searching: false,
      customer_searching: false,
      errors: new Errors(),
      customer_info: null,
      vendor_info: null,
      vendor_credit_amount: null,
      customer_vendors: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('serviceManagement/serviceRequest', ['formViewDatas']),
    serviceRequests() {
      if (this.formViewDatas['serviceRequests']) {
        return this.formViewDatas['serviceRequests'].map(el => ({
          value: el.service_request_id,
          label:
            el.service_request_no +
            (el.customer ? ' | ' + el.customer.customer_name : ''),
          data: el
        }))
      }
      return []
    },
    vendorCustomers() {
      if (this.formViewDatas['customers']) {
        return this.formViewDatas['customers'].map(el => ({
          value: el.customer_id,
          label: el.customer_name
        }))
      }
      return []
    },
    customers() {
      if (this.formViewDatas['customers']) {
        return this.formViewDatas['customers'].map(el => ({
          value: el.customer_id,
          label: el.customer_name
        }))
      }
      return []
    },
    sales() {
      if (this.formViewDatas['sales']) {
        return this.formViewDatas['sales'].map(el => ({
          value: el.employee_id,
          label: el.employee_name_kh + ' | ' + el.employee_name_en,
          user_id: el.user_id
        }))
      }
      return []
    },
    paymentMethods() {
      if (this.formViewDatas['paymentMethods']) {
        return this.formViewDatas['paymentMethods'].map(el => ({
          value: el.payment_method_id,
          label: el.payment_method
        }))
      }
      return []
    },
    bankProfiles() {
      if (this.formViewDatas['bankProfiles']) {
        return this.formViewDatas['bankProfiles'].map(el => ({
          value: el.bank_name,
          label: el.bank_name,
          accounts: el.accounts
        }))
      }
      return []
    },
    accountOptions() {
      let acc = this.bankProfiles.find(b => b.value == this.model.bank_name)
      if (acc) {
        return acc.accounts.map(el => ({
          value: el.account_number,
          label: el.prefix
            ? el.prefix + ' - ' + el.account_number + ' - ' + el.account_name
            : el.account_number + ' - ' + el.account_name,
          name: el.account_name
        }))
      }
      return []
    }
  },
  methods: {
    ...mapActions('serviceManagement/serviceRequest', ['getFormViewModel']),
    setData(data) {
      this.model.customer_id = data.requested_by
      this.model.credit_day = data.customer.credit_day
      let seller = this.sales.find(el => el.user_id == data.owner)
      this.model.seller_id = seller ? seller.value : null
      this.customer_info = data.customer
      this.model.details = []

      if (!data.fee_type) {
          return
      }

      let default_uom = data.fee_type.unit_of_measures.find(u => u.is_default)

      this.model.details.push({
        fee_type_id: data.fee_type_id,
        barcode: data.fee_type.barcode,
        product_name: data.fee_type.product_name_en,
        uom_id: default_uom.uom_id,
        uom_name_en: default_uom.uom_name_en,
        unit_price: data.fee_type.sale_code.find(
          s => s.uom_id == default_uom.uom_id
        ).sale_price,
        quantity: 1,
        customer_cover: true,
        customer_percentage: 100,
        customer_amount: 0,
        vendor_cover: true,
        vendor_percentage: 0,
        vendor_amount: 0
      })
    },
    handleSearchServiceRequest: debounce(async function(value) {
      this.loading = true
      await this.getFormViewModel({
        index: 'serviceRequests',
        params: {
          fnName: 'serviceRequests',
          search_service_request: value
        }
      })
      this.loading = false
    }, 800),
    async onChangeServiceRequest(value, option) {
      this.loading = true
      await this.getFormViewModel({
        index: undefined,
        params: {
          fnName: 'serviceRequests,customers,sales,paymentMethods,bankProfiles',
          owner: option.data.props.data.owner
        }
      })

      this.setData(option.data.props.data)
      this.loading = false
    },
    async onChangeVendor(value, option) {
      await this.getFormViewModel({
        index: undefined,
        params: {
          fnName: 'customers',
        }
      })
      .then(response => {
        this.customer_vendors = response.data.customers
      })
     
      const selectedVendorCustomer = this.customer_vendors.find(customer => customer.customer_id === value);

      this.model.vendor_credit_day = selectedVendorCustomer.credit_day;
      this.vendor_info = selectedVendorCustomer;    
      this.vendor_credit_amount = selectedVendorCustomer.credit_amount != null ? selectedVendorCustomer.credit_amount : 0;    
    },
    onPaymentMethodChange(value) {
      this.model.bank_name = null
      this.model.account_number = null
      this.model.account_name = null
    },
    bankNameChange() {
      this.model.account_number = null
      this.model.account_name = null
    },
    accountChange(value, opt) {
      this.model.account_name = opt.data.props.name
    },
    handleSearchCustomer: debounce(async function(value) {
      this.customer_searching = true
      await this.getFormViewModel({
        index: 'customers',
        params: {
          fnName: 'customers',
          search_customer: value
        }
      })
      this.customer_searching = false
    }, 800)
  }
}
</script>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
</style>
